export const mockModuleMenuResponse = [
    {
        "id": "8ae4b2207ef949de017ef9bd3439003f",
        "showOrder": 0,
        "code": "UDN_PARK",
        "name": "Inicio",
        "url": "/configuration/udn",
        "icon": "fas fa-home",
        "description": null,
        "categoryCode": null,
        "app": {
            "id": "4028b2fc7e697b33017e697e23910000",
            "code": "PARK",
            "fbProject": {
                "id": "8ae4b2207454ccc7017454cd0e9e0001",
                "mainDb": {
                    "id": "8ae4b2207d489870017d4e9a1e130151"
                }
            }
        },
        "menu": {
            "id": "8ae4b2207ef949de017ef9bb61440039"
        },
        "module": {
            "id": "8ae4b2207e2fd065017e34af6b0d00ab"
        }
    },
    {
        "id": "8ae4b2207e2fd065017e34c048070121",
        "showOrder": 1,
        "code": "ACTIVITY_PARK",
        "name": "Actividades",
        "url": "/core/activity",
        "icon": "fas fa-sign",
        "description": null,
        "categoryCode": null,
        "app": {
            "id": "4028b2fc7e697b33017e697e23910000",
            "code": "PARK",
            "fbProject": {
                "id": "8ae4b2207454ccc7017454cd0e9e0001",
                "mainDb": {
                    "id": "8ae4b2207d489870017d4e9a1e130151"
                }
            }
        },
        "menu": {
            "id": "8ae4b2207454ccc7017454cd134a0074"
        },
        "module": {
            "id": "8ae4b2207e2fd065017e34af6b0d00ab"
        }
    },
    {
        "id": "8ae4b2207e2fd065017e34c0e204012a",
        "showOrder": 3,
        "code": "LOCATIONS",
        "name": "Servicios",
        "url": "/atv/location",
        "icon": "fas fa-map-pin",
        "description": null,
        "categoryCode": null,
        "app": {
            "id": "4028b2fc7e697b33017e697e23910000",
            "code": "PARK",
            "fbProject": {
                "id": "8ae4b2207454ccc7017454cd0e9e0001",
                "mainDb": {
                    "id": "8ae4b2207d489870017d4e9a1e130151"
                }
            }
        },
        "menu": {
            "id": "8ae4b2207454ccc7017454cd134c0075"
        },
        "module": {
            "id": "8ae4b2207e2fd065017e34af6b0d00ab"
        }
    },
    {
        "id": "8ae4b2207e2fd065017e34c0bf630127",
        "showOrder": 4,
        "code": "TYPE_SERVICE",
        "name": "Tipos Servicios",
        "url": "/clasificator/services",
        "icon": "fas fa-hand-holding",
        "description": null,
        "categoryCode": null,
        "app": {
            "id": "4028b2fc7e697b33017e697e23910000",
            "code": "PARK",
            "fbProject": {
                "id": "8ae4b2207454ccc7017454cd0e9e0001",
                "mainDb": {
                    "id": "8ae4b2207d489870017d4e9a1e130151"
                }
            }
        },
        "menu": {
            "id": "8ae4b2207454ccc7017454cd128c0063"
        },
        "module": {
            "id": "8ae4b2207e2fd065017e34af6b0d00ab"
        }
    },
    {
        "id": "8ae4b2207e2fd065017e34c0ff04012c",
        "showOrder": 5,
        "code": "ADMISSION_PARK",
        "name": "Entradas",
        "url": "/configuration/admission",
        "icon": "fas fa-ticket-alt",
        "description": null,
        "categoryCode": null,
        "app": {
            "id": "4028b2fc7e697b33017e697e23910000",
            "code": "PARK",
            "fbProject": {
                "id": "8ae4b2207454ccc7017454cd0e9e0001",
                "mainDb": {
                    "id": "8ae4b2207d489870017d4e9a1e130151"
                }
            }
        },
        "menu": {
            "id": "402881cd74e043310174e0456cee0000"
        },
        "module": {
            "id": "8ae4b2207e2fd065017e34af6b0d00ab"
        }
    },
    {
        "id": "8ae4b2207e2fd065017e34c12bb3012e",
        "showOrder": 6,
        "code": "ROUT_PARK",
        "name": "Rutas",
        "url": "/clasificator/rout",
        "icon": "fas fa-map-signs",
        "description": null,
        "categoryCode": null,
        "app": {
            "id": null,
            "code": null,
            "fbProject": {
                "id": null,
                "mainDb": {
                    "id": null
                }
            }
        },
        "menu": {
            "id": "8ae4b2207454ccc7017454cd12890062"
        },
        "module": {
            "id": "8ae4b2207e2fd065017e34af6b0d00ab"
        }
    },
    {
        "id": "8ae4b2207e2fd065017e34c14c620130",
        "showOrder": 7,
        "code": "HAND_PROGRAM",
        "name": "Programas",
        "url": "/atv/program",
        "icon": "fas fa-theater-masks",
        "description": null,
        "categoryCode": null,
        "app": {
            "id": "4028b2fc7e697b33017e697e23910000",
            "code": "PARK",
            "fbProject": {
                "id": "8ae4b2207454ccc7017454cd0e9e0001",
                "mainDb": {
                    "id": "8ae4b2207d489870017d4e9a1e130151"
                }
            }
        },
        "menu": {
            "id": "8ae4b2207454ccc7017454cd13510077"
        },
        "module": {
            "id": "8ae4b2207e2fd065017e34af6b0d00ab"
        }
    },
    {
        "id": "8ae4b2207e2fd065017e34c345d60136",
        "showOrder": 8,
        "code": "HARBOR_HT",
        "name": "Puertos",
        "url": "/xailing/harbor",
        "icon": "fas fa-anchor",
        "description": null,
        "categoryCode": null,
        "app": {
            "id": "4028b2fc7e697b33017e697e82ea0002",
            "code": "HOTEL",
            "fbProject": {
                "id": "8ae4b220786a87e501786a88382f0000",
                "mainDb": {
                    "id": "8ae4b2207ce16d90017ce1724f570000"
                }
            }
        },
        "menu": {
            "id": "8ae4b2207e2fd065017e34c1dfa80132"
        },
        "module": {
            "id": "8ae4b2207e2fd065017e34af6b0d00ab"
        }
    },
    {
        "id": "8ae4b2207e2fd065017e34c35eb70138",
        "showOrder": 9,
        "code": "ROUT_FERRY",
        "name": "Rutas Maritimas",
        "url": "/xailing/xailingRout",
        "icon": "fas fa-ship",
        "description": null,
        "categoryCode": null,
        "app": {
            "id": "4028b2fc7e697b33018e697d82ef0015",
            "code": "FERRY",
            "fbProject": {
                "id": "8ae4b2207ef949de017ef98749fb0019",
                "mainDb": {
                    "id": "ff80808167f3337b0177f33cb8af00d9"
                }
            }
        },
        "menu": {
            "id": "8ae4b2207e2fd065017e34c25de90134"
        },
        "module": {
            "id": "8ae4b2207e2fd065017e34af6b0d00ab"
        }
    }
]

// ----------------------------------------------
//  TableAdapter mocks
// ----------------------------------------------

export const mockTableAdapterRows = [
    { id: 1, code: 'LBL_HOME', description: 'Etiqueta de inicio', appName: 'PARK' },
    { id: 2, code: 'LBL_ACTIVITY', description: 'Etiqueta de actividades', appName: 'PARK' },
    { id: 3, code: 'LBL_SERVICES', description: 'Etiqueta de servicios', appName: 'FERRY' },
    { id: 4, code: 'LBL_CONTACT', description: 'Etiqueta de contacto', appName: 'FERRY' },
    { id: 5, code: 'LBL_ABOUT', description: 'Etiqueta acerca de', appName: 'PARK' },
];

// Columnas básicas, sin acciones ni columnas ocultas.
export const mockTableAdapterBasicColumns = [
    { dataField: 'code', text: 'Código' },
    { dataField: 'description', text: 'Descripción' },
    { dataField: 'appName', text: 'APP' },
];

// Columnas con id oculto, columna de acciones (isDummyField + formatter)
// y columna condicionalmente oculta, replicando el patrón de LabelList._list.js
export const buildMockTableAdapterColumns = ({ hideAppName = false, actionsFormatter } = {}) => ([
    {
        dataField: 'id',
        text: 'ID',
        headerStyle: { width: '0px' },
        hidden: true,
    },
    {
        dataField: 'code',
        text: 'Código',
    },
    {
        dataField: 'description',
        text: 'Descripción',
    },
    {
        dataField: 'appName',
        text: 'APP',
        hidden: hideAppName,
    },
    {
        dataField: 'actions',
        isDummyField: true,
        text: 'Acción',
        headerAlign: 'center',
        align: 'center',
        headerStyle: { width: '150px' },
        formatter: actionsFormatter || (() => null),
    },
]);

// Filas con contenido adicional para demostrar expandRow.
export const mockTableAdapterExpandableRows = mockTableAdapterRows.map(row => ({
    ...row,
    langs: [
        { lang: 'es', value: `${row.description} (ES)` },
        { lang: 'en', value: `${row.description} (EN)` },
    ],
}));

// Dataset más grande para demostrar paginación remota.
export const mockTableAdapterPagedRows = Array.from({ length: 42 }).map((_, index) => ({
    id: index + 1,
    code: `LBL_${String(index + 1).padStart(3, '0')}`,
    description: `Etiqueta demo #${index + 1}`,
    appName: index % 2 === 0 ? 'PARK' : 'FERRY',
}));